<div class="widget-card">
    <div class="widget-head">
        <div>
            <h3>{{ title }}<span class="tag" *ngIf="category">{{ category }}</span><span class="tag source"
                    *ngIf="source">{{ source }}</span></h3>
            <span class="widget-sub" *ngIf="data">{{ selectedAggregation | titlecase }} ·
                {{ data.locations | number }} of {{ data.locations | number }} locations</span>
        </div>
    </div>

    <!-- Config row -->
    <div class="widget-config">
        <label class="cfg">
            <span>Dimension</span>
            <maia-field-select [value]="selectedDimension" [options]="dimensions" placeholder="Select…"
                               (valueChange)="selectedDimension = $event; onConfigChange()"></maia-field-select>
        </label>
        <label class="cfg">
            <span>Measure</span>
            <maia-field-select [value]="selectedMeasure" [options]="measures" placeholder="Select…"
                               [disabled]="selectedAggregation === 'count'"
                               (valueChange)="selectedMeasure = $event; onConfigChange()"></maia-field-select>
        </label>
        <label class="cfg">
            <span>Aggregation</span>
            <select [(ngModel)]="selectedAggregation" (ngModelChange)="onConfigChange()">
                <option *ngFor="let a of aggregations" [value]="a.value">{{ a.label }}</option>
            </select>
        </label>
        <label class="cfg">
            <span>Presentation</span>
            <select [(ngModel)]="selectedPresentation" (ngModelChange)="onPresentationChange()">
                <option *ngFor="let p of presentations" [value]="p.value">{{ p.label }}</option>
            </select>
        </label>
        <label class="cfg-check">
            <input type="checkbox" [(ngModel)]="includeTable" />
            <span>Include data table</span>
        </label>
    </div>

    <div class="widget-scope">
        <span class="scope-label">SCOPE</span>
        <button type="button" class="scope-filter" disabled>+ Filter</button>
        <span class="scope-note">Entire file. Add a filter to target a narrower slice.</span>
    </div>

    <p class="widget-loading" *ngIf="loading">Loading…</p>

    <ng-container *ngIf="!loading && data">
        <div class="empty-state" *ngIf="!items.length">
            <strong>No data for this selection</strong><br>
            This dimension isn't present (or is empty) in the file. Pick another dimension.
        </div>

        <ng-container *ngIf="items.length">
            <div class="at-a-glance"><strong>At a glance</strong> {{ atAGlance }}</div>

            <div class="widget-chart" *ngIf="showChart" echarts [options]="chartOptions"></div>

            <div class="table-wrap" *ngIf="showTable">
                <table class="report-table">
                    <thead>
                        <tr>
                            <th>{{ selectedDimension }}</th>
                            <th class="num">{{ selectedAggregation === 'count' ? 'Locations' : selectedMeasure }}</th>
                            <th class="num">Locations</th>
                            <th class="num">Share</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let it of items">
                            <td>{{ it.label }}</td>
                            <td class="num">{{ fmt(it.value) }}</td>
                            <td class="num">{{ it.count | number }}</td>
                            <td class="num">{{ share(it.value) }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </ng-container>
    </ng-container>

    <p class="empty-state" *ngIf="!loading && !data && !selectedDimension">
        Choose a dimension to build this section.
    </p>
</div>
